import {InvCreateType} from "../interface";

export const invCreateInit: InvCreateType = {
    barcode: "",
    inventoryUnit: 0,
    newErpProductid: "",
    originalPrice: 0,
    safetyAmount: 0,
    sellingPrice: 0
}